// extracted by mini-css-extract-plugin
export default {"card":"k2-z"};